var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { forwardRef } from "react";
import styled from "styled-components";
export var Container = forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, tabIndex = _a.tabIndex, onFocus = _a.onFocus, onBlur = _a.onBlur, role = _a.role, ariaHaspopup = _a["aria-haspopup"], ariaExpanded = _a["aria-expanded"];
    return (React.createElement(Wrapper, { ref: ref, className: className, tabIndex: tabIndex, onFocus: onFocus, onBlur: onBlur, role: role, "aria-haspopup": ariaHaspopup, "aria-expanded": ariaExpanded }, children));
});
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n"], ["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n"])));
var templateObject_1;
